import { useEffect, useState } from "react";
import { format } from 'date-fns';
import {PurchaseOrderForm} from "./Forms/PurchaseOrderForm";
import {API} from "../api/config";
import Modal from "./Modal";

export const PurchaseOrders = () => {
    const [purchaseOrders, setPurchaseOrders] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPO, setSelectedPO] = useState(null);

    useEffect(() => {
        fetchPurchaseOrders();
    }, []);

    const fetchPurchaseOrders = async () => {
        try {
            const response = await fetch(API.purchaseOrders.list());
            const data = await response.json();
            setPurchaseOrders(data);
        } catch (error) {
            console.error('Error fetching POs:', error);
        }
    };

    const handleNewPO = () => {
        setSelectedPO(null);
        setIsModalOpen(true);
    };

    const viewPO = (po) => {
        setSelectedPO(po);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedPO(null);
        fetchPurchaseOrders(); // Refresh the list after modal closes
    };

    const deletePO = async (id) => {
        try {
            await fetch(API.purchaseOrders.delete(id), {
                method: 'DELETE'
            });
            fetchPurchaseOrders();
        } catch (error) {
            console.error('Error deleting PO:', error);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return format(date, 'MMMM dd, yyyy');
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(amount);
    };

    return (
        <div className="container mx-auto p-4">
            <div className="flex justify-between items-center mb-4">
                <h1 className="text-2xl font-bold">Purchase Orders</h1>
                <button
                    onClick={handleNewPO}
                    className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                >
                    New PO
                </button>
            </div>
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200">
                    <thead>
                    <tr>
                        <th className="py-2 px-4 border-b">PO Number</th>
                        <th className="py-2 px-4 border-b">Vendor</th>
                        <th className="py-2 px-4 border-b">Date Required</th>
                        <th className="py-2 px-4 border-b">Total Amount</th>
                        <th className="py-2 px-4 border-b">Status</th>
                        <th className="py-2 px-4 border-b">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {purchaseOrders.map((po) => (
                        <tr key={po.id} className="hover:bg-gray-100">
                            <td className="py-2 px-4 border-b">{po.poNumber}</td>
                            <td className="py-2 px-4 border-b">{po.vendor.name}</td>
                            <td className="py-2 px-4 border-b">{formatDate(po.dateRequired)}</td>
                            <td className="py-2 px-4 border-b">{formatCurrency(po.totalAmount)}</td>
                            <td className="py-2 px-4 border-b">
                                    <span className={`px-2 py-1 rounded text-sm ${
                                        po.isApproved ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                                    }`}>
                                        {po.isApproved ? 'Approved' : 'Pending'}
                                    </span>
                            </td>
                            <td className="py-2 px-4 border-b space-x-2">
                                <button
                                    onClick={() => viewPO(po)}
                                    className="px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 mr-2"
                                >
                                    View
                                </button>
                                {!po.isApproved && (
                                    <button
                                        onClick={() => deletePO(po.id)}
                                        className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                                    >
                                        Delete
                                    </button>
                                )}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            <Modal isOpen={isModalOpen} onClose={closeModal}>
                <PurchaseOrderForm
                    initialData={selectedPO}
                    onSubmit={() => {
                        closeModal();
                        fetchPurchaseOrders();
                    }}
                />
            </Modal>
        </div>
    );
};